import { Tabs } from "antd";
import React, { useState } from "react";
import MainGrossProfitReport from "./grossProfit/MainGrossProfitReport";

export default function BudgetProfitExpense() {
  const [tabChange, setTabChange] = useState(null);

  const handleTabChange = (value) => {
    setTabChange(value);
  };
  const items = [
    {
      key: "Gross Profit Report",
      label: (
        <div className="text-center" style={{ color: "#46604A" }}>
          Gross Profit Report
        </div>
      ),
      children: <MainGrossProfitReport tabChange={tabChange} />,
    },
    {
      key: "Expense Report",
      label: (
        <div className="text-center" style={{ color: "#46604A" }}>
          Expense Report
        </div>
      ),
      children: null,
    },
    {
      key: "Budget Report",
      label: (
        <div className="text-center" style={{ color: "#46604A" }}>
          Budget Report
        </div>
      ),
      children: null,
    },
  ];
  return (
    <>
      <div className="consultationDashboard">
        <div className="dashboardNameSection">
          <h5 style={{ color: "#46604A" }}>
            BUDGET, EXPENSE & GROSS PROFIT REPORT
          </h5>
        </div>
        <div className="consultationDashboardContainer shadow-sm rounded">
          <Tabs
            onChange={handleTabChange}
            className="px-4 mt-4 custom-tabs"
            defaultActiveKey="Purchase Report"
            items={items}
          />
        </div>
      </div>
    </>
  );
}
